import ReactECharts from 'echarts-for-react';
import { Radio } from 'antd';
import { formatName } from './rep-product-data-grouping'
import { isMobile } from '../../../extensions/design';

const chartTypes = [
  { value: 'pie', label: 'Круговая' },
  { value: 'bar', label: 'Гистограмма' },
  // { value: 'proportion', label: 'Пропорции' },
];

const chartColors = [
  '#fbc02d', '#1976d2', '#0288d1', '#388e3c', '#d32f2f', '#7b1fa2', '#ffa000', '#0288d1', '#388e3c', '#d32f2f', '#7b1fa2', '#ffa000'
];

// Боковой график финансового отчета
const RepProductReportGraph = ({ data, chartType, setChartType }) => {
  const chartData = data.map((row, idx) => ({
    value: row.total,
    name: row.name,
    itemStyle: { color: chartColors[idx % chartColors.length] }
  }));

  const pieOption = {
    tooltip: { trigger: 'item' },
    series: [
      {
        name: 'Сотрудник',
        type: 'pie',
        radius: ['60%', '90%'],
        avoidLabelOverlap: false,
        label: { show: true, position: 'inside', formatter: '{d}%' },
        labelLine: { show: false },
        data: chartData,
      },
    ],
  };
  const barOption = {
    tooltip: { trigger: 'axis' },
    grid: { left: 72, right: 10, top: 20, bottom: 130 },
    xAxis: { 
      type: 'category', 
      data: data.map(row => formatName(row.name)),
      axisLabel: { rotate: 90 }
    },
    yAxis: { 
      type: 'value', 
      max: null,
      axisLabel: { formatter: function(value) { return value.toLocaleString(); } }
    },
    series: [
      {
        data: data.map(row => row.total),
        type: 'bar',
        itemStyle: { color: (params) => chartColors[params.dataIndex % chartColors.length], },
      },
    ],
  };
  const totalSum = data.reduce((acc, row) => acc + row.total, 0);
  const proportionOption = {
    tooltip: { trigger: 'axis' },
    grid: { left: 72, right: 10, top: 20, bottom: 130 },
    xAxis: { 
      type: 'category', 
      data: data.map(row => formatName(row.name)),
      axisLabel: { rotate: 90 }
    },
    yAxis: { type: 'value', max: 1 },
    series: [
      {
        data: data.map(row => totalSum ? row.total / totalSum : 0),
        type: 'bar',
        itemStyle: { color: (params) => chartColors[params.dataIndex % chartColors.length], },
      },
    ],
  };
  const chartOption = chartType === 'pie' ? pieOption : chartType === 'bar' ? barOption : proportionOption;

  if (isMobile)
    return (
      <div className="graph-container">
        <ReactECharts key={chartType} option={chartOption} className='echarts-graph'/>
        <div className="graph-radio-row">
          <Radio.Group
            options={chartTypes}
            value={chartType}
            optionType="button"
            buttonStyle="solid"
            onChange={e => setChartType(e.target.value)}
          />
        </div>    
      </div>
  );

  return (
    <div className="graph-container">
        <div className="graph-radio-row">
          <Radio.Group
            options={chartTypes}
            value={chartType}
            optionType="button"
            buttonStyle="solid"
            onChange={e => setChartType(e.target.value)}
          />
        </div>
      <ReactECharts key={chartType} option={chartOption} className='echarts-graph'/>
    </div>
  );
}

export default RepProductReportGraph;